<template>
  <div class="ComfirmOrder">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">采购订单</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ order.OrderNumber }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="change_inform">
      <div class="title">订单信息</div>
      <div>
        <el-form :inline="true" :model="order" class="form_table" ref="form" :inline-message="true">
          <el-form-item label="甲方">广电计量检测集团股份有限公司 </el-form-item>
          <el-form-item label="乙方">{{ order.SupplierName }}</el-form-item>
          <el-form-item label="订单编号">{{ order.OrderNumber }}</el-form-item>
          <el-form-item label="订单日期">{{ order.CreateDate }}</el-form-item>
          <el-form-item label="成本公司">{{ order.CompanyName }}</el-form-item>
          <el-form-item label="所属中心">{{ order.BelongCenterName }}</el-form-item>
        </el-form>
      </div>
      <div class="title">
        货物清单
        <span style="color: orange">
          <img src="@/assets/img/icon_tips0.png" />
          供应商收到订单后，对于部分缺货、周期过长等异常情况，请及时联系广电人员。并将确认结果填写到下表的异常说明中
        </span>
      </div>
      <div>
        <el-table :data="materialList" class="table_wrap1" border>
          <el-table-column type="index" width="50" label="序号"></el-table-column>
          <el-table-column prop="MaterialCode" label="物品代码" width="100"></el-table-column>
          <el-table-column prop="MaterialName" label="物品名称"></el-table-column>
          <el-table-column prop="Specification" label="品牌规格"></el-table-column>
          <el-table-column prop="PerPrice" label="单价（元）" width="100"></el-table-column>
          <el-table-column prop="Count" label="采购数量" width="100"></el-table-column>
          <el-table-column prop="SumFee" label="金额（元）" width="100"></el-table-column>
          <el-table-column prop="ReceivingCompany" label="收货公司"></el-table-column>
          <el-table-column prop="ExpectedArrivalTime" label="期望到货日期"></el-table-column>
          <el-table-column prop="CenterName" label="所属中心"></el-table-column>
          <el-table-column prop="PurchaseReason" label="备注"></el-table-column>
          <el-table-column label="确认结果">
            <template slot-scope="scope">
              <el-select v-model="scope.row.ConfirmResults" placeholder="请选择" style="margin-left: 20px">
                <el-option v-for="item in resultList" :key="item.Value" :label="item.Text" :value="item.Value"> </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="确认数量" width="200">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.ActualCount" v-if="scope.row.ConfirmResults == 2" controls-position="right" :min="1" :max="scope.row.Count"></el-input-number>
            </template>
          </el-table-column>
          <el-table-column prop="ConfirmDescription" label="异常说明" width="250">
            <template slot-scope="scope">
              <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="scope.row.ConfirmDescription" style="width: 90%"> </el-input>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="btn_wrap changeInform_btn_wrap">
        <span class="btn_1" @click="fnGoBack()">返回</span>
        <span class="btn_1" @click="fnSave()">提交</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      resultList: [],
      materialList: [],
      order: {}
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      let config = {
        params: {
          OrderId: this.$route.query.OrderId
        }
      }
      this.getRequest('/Order/GetOrderData', config).then((res) => {
        if (res.data.errcode == 0) {
          this.resultList = res.data.resultList
          this.materialList = res.data.materialList
          this.order = res.data.order
          this.materialList.forEach((item) => {
            if (Number(item.ConfirmResults) == 0) {
              item.ConfirmResults = ''
            }
          })
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },

    fnGoBack() {
      window.close()
    },

    fnSave() {
      let that = this
      var flag = true
      that.materialList.forEach((item) => {
        if (item.ConfirmResults == '' && flag == true) {
          that.$message.error(`请选择${item.MaterialName}的确认结果`)
          flag = false
        }
        if (item.ConfirmResults != 1 && item.ConfirmDescription == '' && flag == true) {
          that.$message.error(`请输入${item.MaterialName}的异常说明`)
          flag = false
        }
      })
      if (flag == true) {
        let materialListJson = JSON.stringify(that.materialList)
        this.postRequest('/Order/ComfirmOrder', {
          OrderId: this.$route.query.OrderId,
          materialListJson: materialListJson
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.$message.success('提交成功')
            localStorage.setItem('orderList', Math.random())
            setTimeout(() => {
              window.close()
            }, 1000)
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ComfirmOrder {
  .right_content {
    margin: 0 10px;
    height: 93%;
    background: #fff;
  }

  .title2 {
    font-size: 18px;
    border-bottom: 1px solid #95c7f0;
    padding-bottom: 7px;
    margin: 7px;
  }

  //重写el_tabs样式
  .el_tabs {
    margin: 7px 7px 0;
  }

  .el_tabs ::v-deep .el-tabs__header {
    float: none;
    margin-right: 0;
    margin-bottom: 0;

    .el-tabs__nav-wrap::after {
      background-color: #95c7f0;
    }

    .el-tabs__item {
      padding: 0 40px;
      color: #054c81;
    }

    .el-tabs__item.is-active {
      color: #fff;
      background: #2db7f5;
    }

    .el-tabs__active-bar {
      display: none;
    }
  }

  //重写el-table样式
  .el_table {
    width: 98%;
    margin: 0 auto;
    border: none;
  }

  .el_table ::v-deep .el-table__header {
    th {
      background: #d8eafa;
      text-align: center;
      border-bottom: 2px solid #e4e4e4;
      color: #333;
    }
  }

  .el_table ::v-deep .el-table__body-wrapper {
    tr {
      background-color: #e6f6fb;
    }

    td {
      text-align: center;
      border-bottom: 1px solid #e4e4e4;
      border-right: none;
      background-color: #fff;
    }
  }

  .change_inform ::v-deep.icon_tips2 {
    vertical-align: middle !important;
  }

  .changeInform_btn_wrap {
    width: 366px;
    margin: 40px auto 0;

    .btn_1 {
      background: #f60;
      border: 1px solid #f60;
      color: #fff;
      border-radius: 8px;
    }

    .btn_1:nth-of-type(1) {
      margin-right: 30px;
    }
  }

  .title2_span {
    margin-left: auto;
    color: #0660a2;
    font-weight: bold;
    font-size: 13px;
  }

  .btn {
    margin-left: 50px;
    color: #fff;
    border: 1px solid #6a96bc;
    border-radius: 5px;
    padding: 2px 18px;
    font-size: 15px;
    background: #2db7f5;
  }

  .change_inform {
    padding-top: 15px;

    .title {
      height: 34px !important;
      line-height: 40px !important;
      border-bottom: 1px solid #95c7f0 !important;
      margin-bottom: 13px;
      // padding-top: 15px !important;
    }

    ::v-deep .el-table--border::after,
    .el-table--group::after,
    .el-table::before {
      background-color: #95c7f0;
    }

    ::v-deep .table_wrap1 {
      table {
        margin: 0;

        td,
        tr,
        th {
          border-color: #95c7f0;
        }

        th {
          border-top: 1px solid #95c7f0;
          border-right: 1px solid #95c7f0;
          border-color: #95c7f0;
          background-color: #d8eafa;

          &:first-child {
            border-left: 1px solid #95c7f0;
          }
        }

        td {
          border-bottom: none;

          &:first-child {
            border-left: 1px solid #95c7f0;
          }
        }
      }

      .el-table__body-wrapper {
        border-bottom: 1px solid #95c7f0;
      }
    }
  }
}
</style>